<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup" *ngIf="model === 'undefined'">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'SUPPLIER_SELECT.SUPPLIER' | translate }}
    </span>

    <span *ngIf="parentFormGroup.get(passFormControlName).value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>

  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    (change)="onChange($event)"
    [items]="data | async"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    [formControlName]="passFormControlName"
    [typeahead]="input$"
    appendTo="body"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'SUPPLIER_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      (change)="onChange($event)"
      [items]="data | async"
      bindLabel="name"
      bindValue="id"
      [loading]="loader"
      [formControlName]="passFormControlName"
      appendTo="body"
      [typeahead]="input$"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'SUPPLIER_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>
</div>

<div class="form-group" *ngIf="model !== 'undefined'">
  <label>{{ 'SUPPLIER_SELECT.SUPPLIER' | translate }}</label>
  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [items]="data | async"
    bindLabel="name"
    [loading]="loader"
    [(ngModel)]="model"
    (change)="changeModel($event)"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'SUPPLIER_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      [items]="data | async"
      bindLabel="name"
      [loading]="loader"
      [(ngModel)]="model"
      (change)="changeModel($event)"
      appendTo="body"
      [typeahead]="input$"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'SUPPLIER_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>
</div>
